import React, { useState, useEffect } from 'react';
import { FaArchive, FaListOl, FaBook, FaSearch, FaBookmark, FaCog, FaFolder, FaUser, FaNewspaper, FaIndent, FaArrowRight, FaBars, FaClinicMedical, FaIdCard, FaHome} from 'react-icons/fa';
import Nav from 'react-bootstrap/Nav';
import BotonMenuP from './botonMenuPrincipal';
import BotonMenuN from './BotonMenuNavegar';
import { useAuth } from '../../Auth/AuthContext';
import { savePermisosPaginas, getPermisosPaginas } from '../Utils/indexedDBUtils';
import "./AppMenu.css";
import { FastfoodOutlined } from '@mui/icons-material';

export default function AppMenu() {
    const { rol, fetchPermisosPaginas, rolNombre, programa } = useAuth();
    const [mostrarSubmenuDiagnostico, setMostrarSubmenuDiagnostico] = useState(false);
    const [mostrarSubmenuCaracterizacion, setMostrarSubmenuCaracterizacion] = useState(false);
    const [mostrarSubmenuSSV, setMostrarSubmenuSSV] = useState(false);
    const [mostrarSubmenuConf, setMostrarSubmenuConf] = useState(false);
    const [mostrarSubmenuInformes, setMostrarSubmenuInformes] = useState(false);
    const [mostrarSubmenuReincorporados, setMostrarSubmenuReincorporados] = useState(false);
    const [mostrarSubmenuOrganizaciones, setMostrarSubmenuOrganizaciones] = useState(false);
    const [permisosPaginas, setPermisosPaginas] = useState([]);
    const consultarPermisosPaginas = React.useCallback(async () => {
        const cachedPermisos = await getPermisosPaginas();
        if (cachedPermisos) {
            setPermisosPaginas(cachedPermisos);
        } else {
            // If not in IndexedDB, fetch from the API
            const permisos = await fetchPermisosPaginas();
            if (permisos) {
                setPermisosPaginas(permisos);
                await savePermisosPaginas(permisos); // Save the result to IndexedDB
            }
        }
    }, [fetchPermisosPaginas]);
    const menuItems = [
      {
        title: "Pagina principal",
        direccion: programa === "1" ? "/dashboard" : "/reincorporados",
        icon: <FaIndent />,
        submenu: null
      },
      {
        title: "Caracterización",
        accion: () => {setMostrarSubmenuCaracterizacion(!mostrarSubmenuCaracterizacion)},
        icon: <FaArrowRight />,
        submenu: mostrarSubmenuCaracterizacion ? [
          { title: "Consulta persona", 
            direccion: "/caracterizacion/consultapersona", icon: <FaSearch />,
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "Consulta persona")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol)) 
          },
          { title: "Bodega de AHE", direccion: "/bodega/ahe", icon: <FastfoodOutlined />,
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "AHE")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol))  },
          { title: "Albergues", direccion: "/albergues/permanenciaalbergue", icon: <FaHome />,
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "Albergue")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol))  },
          { title: "Derecho Identidad", direccion: "/caracterizacion/derechoidentidad", icon: <FaIdCard />,
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "Derecho Identidad")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol))
          },
          { title: "Psicosociales", direccion: "/caracterizacion/psicosociales", icon: <FaClinicMedical />,
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "Psicosociales")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol))
          },
          { title: "Archivo", direccion: "/archivo/0", icon: <FaFolder />,
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "Archivo")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol))  }
        ] : null
      },
      {
        title: "Organizaciones",
        accion: () => {setMostrarSubmenuOrganizaciones(!mostrarSubmenuOrganizaciones)},
        icon: <FaArrowRight />,
        submenu: mostrarSubmenuOrganizaciones ? [
          { title: "Organizaciones", direccion: "/organizaciones/listar", icon: <FaFolder />,
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "Organizaciones")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol))  },
        ] : null
      },
      {
        title: "Diagnostico base",
        accion: () => setMostrarSubmenuDiagnostico(!mostrarSubmenuDiagnostico),
        icon: <FaArrowRight />,
        submenu: mostrarSubmenuDiagnostico ? [
          { title: "Recepción", direccion: "/dx/recepciondx", icon: <FaListOl />,
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "Recepcion dx")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol)) },
          { title: "Diágnostico", direccion: "/dx/diagnosticodx", icon: <FaBook />,
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "Diagnostico dx")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol)) },
          { title: "Consulta DX", direccion: "/diagnostico/consultadx", icon: <FaSearch />,
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "Consulta DX")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol)) },
          { title: "Asistencia", direccion: "/diagnostico/asistenciadx", icon: <FaBookmark />,
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "Asistencia dx")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol)) },
          { title: "Caracterizacion dfi", direccion: "/dx/caracterizaciondfi", icon: <FaBookmark />,
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "Caracterizacion dfi")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol)) },
          { title: "Revision dx", direccion: "/dx/revisiondx", icon: <FaBookmark />,
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "Revision dx")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol)) },
          { title: "AHE", direccion: "/diagnostico/ahedx", icon: <FaArchive />,
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "AHE dx")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol)) }
        ] : null
      },
      {
        title: "Encuesta SSV",
        accion: () => setMostrarSubmenuSSV(!mostrarSubmenuSSV),
        icon: <FaArrowRight />,
        submenu: mostrarSubmenuSSV ? [
          { title: "Cuestionario", direccion: "/encuestassv/id/0", icon: <FaUser />,
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "Cuestionario SSV")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol)) },
          { title: "Previsitas", direccion: "/encuestassv/previsitas", icon: <FaNewspaper />,
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "Previsitas SSV")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol)) },
          { title: "Reportes", direccion: "/encuestassv/reportes", icon: <FaNewspaper />,
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "Reportes SSV")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol)) },
          { title: "Consultas", direccion: "/encuestassv/consultas", icon: <FaNewspaper />,
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "Consultas SSV")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol)) },
          { title: "Usuarios", direccion: "/encuestassv/reportes", icon: <FaUser />,
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "Usuarios SSV")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol)) }
        ] : null
      },
      {
        title: "Configuraciones",
        accion: () => setMostrarSubmenuConf(!mostrarSubmenuConf),
        icon: <FaArrowRight />,
        submenu: mostrarSubmenuConf ? [
          { title: "Configuración", direccion: "/parametros", icon: <FaUser />},
          { title: "Administrar", direccion: "/caracterizacion/administrarcaracterizacion", icon: <FaCog />,
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "Administrar")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol)) }
        ] : null
      },
      {
        title: "Menu Informes",
        accion: () => setMostrarSubmenuInformes(!mostrarSubmenuInformes),
        icon: <FaArrowRight />,
        submenu: mostrarSubmenuInformes ? [
          { title: "Informes", direccion: "/caracterizacion/informesadministrativos", icon: <FaCog />,
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "Menu Informes")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol))  },
          { title: "Reportes", direccion: "/caracterizacion/reportes", icon: <FaCog />,
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "Menu Reportes")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol))  },
          { title: "Ver diagnosticos", direccion: "consultas/verdiagnosticos", icon: <FaCog />,
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "Ver Diagnosticos")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol))  },
          { title: "Inf Estadístico", direccion: "consultas/verestadisticos", icon: <FaCog />,
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "Inf Estadistico")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol))  },
          
        ] : null
      },
      {
        title: "Menu Reincorporados",
        accion: () => setMostrarSubmenuReincorporados(!mostrarSubmenuReincorporados),
        icon: <FaArrowRight />,
        submenu: mostrarSubmenuReincorporados ? [
          { title: "Consulta persona", direccion: "/reincorporados/consultarrei", icon: <FaListOl />,
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "Consultar Reincorporados")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol))  },
          
        ] : null
      }
    ];

    useEffect(() => {
        consultarPermisosPaginas();
    }, [consultarPermisosPaginas]);

    return (
      <aside className="main-sidebar sidebar-light elevation-4" style={{ backgroundColor: "whitesmoke" }}>
      
      <div
        className="brand-link"
        style={{ backgroundColor: '#3c8dbc', textAlign: 'center', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}
      >
        <span className="brand-text" style={{ color: 'white' }}>VIDAR</span>
        <button
          className="nav-link"
          onClick={() => {
            document.body.classList.remove('sidebar-open')
          }}
          type="button"
          style={{
            background: 'none',
            border: 'none',
            padding: 0,
            marginLeft: 8,
          }}
          id="sidebar-close-btn"
        >
          <FaBars style={{ color: 'white' }} />
        </button>
      </div>
      
      <div className="sidebar os-host os-host-overflow os-host-overflow-y os-host-resize-disabled os-host-scrollbar-horizontal-hidden os-host-transition">
      <div className="user-panel mt-3 pb-3 mb-3 d-flex" style={{ justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
      <div className='image' style={{ textAlign: 'center' }}>
        <img src="/dist/img/logo_login.png" className="img-square" alt="User" style={{ width: '100%', height: '100%' }} />
      </div>
      <div className="info" style={{ textAlign: 'center' }}>
        <h5>{rolNombre}</h5>
      </div>
      </div>
      
      <div className="form-inline" style={{ textAlign: 'center' }}>
      <div>
        <h6>MENU</h6>
      </div>
      </div>
      
      <Nav
      navbar={true}
      navbarScroll={true}
      activeKey="/"
      style={{ display: "flex", flexDirection: "column", alignItems: "left" }}
      >
        <Nav.Item className='navcolorgray'><BotonMenuN Titulo="Pagina principal" direccion={programa === "1" ? '/dashboard' : '/reincorporados'}><FaIndent /></BotonMenuN></Nav.Item>
        {permisosPaginas
          .filter(pagina => pagina.ppa_nombrepag === "Menu caracterizacion")
          .map(pagina => pagina.ppe_rolid)
          .includes(Number.parseInt(rol)) && <Nav.Item className='navcolorgray'>
            <BotonMenuP Titulo="Caracterización" accion={() => setMostrarSubmenuCaracterizacion(!mostrarSubmenuCaracterizacion)}><FaArrowRight /></BotonMenuP></Nav.Item>}
        
        {mostrarSubmenuCaracterizacion && 
        <div>
          {menuItems.find(item => item.title === "Caracterización").submenu?.map((submenuItem, index) => (
          <Nav.Item hidden={submenuItem.hidden} key={submenuItem.direccion}>
            <BotonMenuN  Titulo={submenuItem.title} direccion={submenuItem.direccion}>
            {submenuItem.icon}
            </BotonMenuN>
          </Nav.Item>
          ))}
        </div>
        }        
        {permisosPaginas
          .filter(pagina => pagina.ppa_nombrepag === "Menu diagnostico")
          .map(pagina => pagina.ppe_rolid)
          .includes(Number.parseInt(rol)) && <Nav.Item className='navcolorgray'><BotonMenuP Titulo="Diagnostico base" accion={() => setMostrarSubmenuDiagnostico(!mostrarSubmenuDiagnostico)}><FaArrowRight /></BotonMenuP></Nav.Item>}
        {mostrarSubmenuDiagnostico && 
        <div>
        {menuItems.find(item => item.title === "Diagnostico base").submenu?.map((submenuItem, index) => (
          <Nav.Item hidden={submenuItem.hidden}  key={submenuItem.direccion}>
          <BotonMenuN Titulo={submenuItem.title} direccion={submenuItem.direccion}>
            {submenuItem.icon}
          </BotonMenuN>
          </Nav.Item>
        ))}
        </div>
        }
        {permisosPaginas
          .filter(pagina => pagina.ppa_nombrepag === "Menu organizaciones")
          .map(pagina => pagina.ppe_rolid)
          .includes(Number.parseInt(rol)) && <Nav.Item className='navcolorgray'><BotonMenuP Titulo="Organizaciones" accion={() => setMostrarSubmenuOrganizaciones(!mostrarSubmenuOrganizaciones)}><FaArrowRight /></BotonMenuP></Nav.Item>}
        {mostrarSubmenuOrganizaciones && 
        <div>
        {menuItems.find(item => item.title === "Organizaciones").submenu?.map((submenuItem, index) => (
          <Nav.Item hidden={submenuItem.hidden}  key={submenuItem.direccion}>
          <BotonMenuN Titulo={submenuItem.title} direccion={submenuItem.direccion}>
            {submenuItem.icon}
          </BotonMenuN>
          </Nav.Item>
        ))}
        </div>
        }
        {permisosPaginas
          .filter(pagina => pagina.ppa_nombrepag === "Menu SSV")
          .map(pagina => pagina.ppe_rolid)
          .includes(Number.parseInt(rol)) && <Nav.Item className='navcolorgray'><BotonMenuP Titulo="Encuesta SSV" accion={() => setMostrarSubmenuSSV(!mostrarSubmenuSSV)}><FaArrowRight /></BotonMenuP></Nav.Item>}
        {mostrarSubmenuSSV && 
        <div>
        {menuItems.find(item => item.title === "Encuesta SSV").submenu?.map((submenuItem, index) => (
          <Nav.Item hidden={submenuItem.hidden} key={submenuItem.direccion}>
          <BotonMenuN Titulo={submenuItem.title} direccion={submenuItem.direccion}>
            {submenuItem.icon}
          </BotonMenuN>
          </Nav.Item>
        ))}
        </div>
        }
        {permisosPaginas
          .filter(pagina => pagina.ppa_nombrepag === "Menu Reincorporados")
          .map(pagina => pagina.ppe_rolid)
          .includes(Number.parseInt(rol)) && <Nav.Item className='navcolorgray'><BotonMenuP Titulo="Reincorporados" accion={() => setMostrarSubmenuReincorporados(!mostrarSubmenuReincorporados)}><FaArrowRight /></BotonMenuP></Nav.Item>}
        {mostrarSubmenuReincorporados && 
        <div>
        {menuItems.find(item => item.title === "Menu Reincorporados").submenu?.map((submenuItem, index) => (
          <Nav.Item hidden={submenuItem.hidden}  key={submenuItem.direccion}>
          <BotonMenuN Titulo={submenuItem.title} direccion={submenuItem.direccion}>
            {submenuItem.icon}
          </BotonMenuN>
          </Nav.Item>
        ))}
        </div>
        }        
        {(rol === '2' || rol === '27') && <Nav.Item className='navcolorgray'><BotonMenuP Titulo="Informes" accion={() => setMostrarSubmenuInformes(!mostrarSubmenuInformes)}><FaArrowRight /></BotonMenuP></Nav.Item>}
        {mostrarSubmenuInformes && 
        <div>
        {menuItems.find(item => item.title === "Menu Informes").submenu?.map((submenuItem, index) => (
          <Nav.Item hidden={submenuItem.hidden} key={submenuItem.direccion}>
          <BotonMenuN Titulo={submenuItem.title} direccion={submenuItem.direccion}>
            {submenuItem.icon}
          </BotonMenuN>
          </Nav.Item>
        ))}
        </div>
        }
        {rol === '2' && <Nav.Item className='navcolorgray'><BotonMenuP Titulo="Configuraciones" accion={() => setMostrarSubmenuConf(!mostrarSubmenuConf)}><FaArrowRight /></BotonMenuP></Nav.Item>}
        {mostrarSubmenuConf && rol === '2' && 
        <div>
          {menuItems.find(item => item.title === "Configuraciones").submenu?.map((submenuItem, index) => (
          <Nav.Item key={submenuItem.direccion}>
            <BotonMenuN Titulo={submenuItem.title} direccion={submenuItem.direccion}>
            {submenuItem.icon}
            </BotonMenuN>
          </Nav.Item>
          ))}
        </div>
        }
      </Nav>
      </div>
      
      </aside>
    )
  }
